import React, { useState, useMemo, useCallback, useEffect } from 'react';
import SomaTable from '../../../../components/SomaStandard/SomaTable/SomaTable';
import SomaFilter from '../../../../components/SomaStandard/SomaFilter';
import { pageList } from '../../../../helpers/webHelper';
import Modal from '../../../../components/Modal';
import FormVendedor from '../FormVendedor';
import FormVendedorEdit from '../FormVendedorEdit';
import Tabelas from '../../../../components/SomaStandard/TableComponents/Tabelas';
import AffiliateButtonGroup from '../AffiliateButtonGroup/AffiliateButtonGroup';
import SomaStatus from '../../../../components/SomaStandard/SomaStatus';
import './ListaAfiliados.css'
import PrimaryButton from '../../../../components/PrimaryButton/PrimaryButton';
import TableSettings from '../../../../components/TableSettings/TableSettings'
import SomaRadioButton from '../../../../components/SomaStandard/SomaRadioButton';
import SomaTextEditor from '../../../../components/SomaStandard/SomaTextEditor/SomaTextEditor';
import useUser from '../../../../Hooks/UserContext';
import ToggleFilter from '../../../../components/SomaStandard/ToggleFilter';
import ConverteData from '../../../../components/SomaStandard/TableComponents/ConverteData';

const parseCPF = (cpf) => cpf.match(/\d/g)?.slice(0, 11).map((c, i) => { if (i === 3 || i === 6) return '.' + c; if (i === 9) return '-' + c; return c; }).join('');
const parseSocialMedia = (id) => id ? `@${id}` : id;

const ListaAfiliados = (props) => {
  const hasButton = true;
  const user = useUser();
  const [status, setStatus] = useState('result')

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(25);

  const [onConfirm, setOnConfirm] = useState(() => 0);
  const [open, setOpen] = useState(false);
  const [loadingRemoveVendor, setLoadingRemoveVendor] = useState(false)
  const [reasonRemoveVendor, setReasonRemoveVendor] = useState(undefined)
  const [commentRemoveVendor, setCommentRemoveVendor] = useState(undefined)

  const [edit, setEdit] = useState(undefined);
  const [openModal, setOpenModal] = useState(false);

  const [openModalEdit, setOpenModalEdit] = useState(false);
  const [editInfo, setEditInfo] = useState({})

  const [filter, setFilter] = useState('')
  const [filteredResults, setFilteredResults] = useState([])

  const { reload } = props;

  const tabs = [
    { key: "1", value: "ATIVADOS", color: "#148A6A" },
    { key: "2", value: "DESATIVADOS", color: "#D66157" },
  ];

  const toggleOpts = {
    opts: tabs,
    valorAtivo: props.statusAff || "1",
    handleChange: (e, newStatus) => {
      if (newStatus) {
        props.setStatusAff(newStatus)
        setFilter("")
        setPage(0);
      }
    },
  };

  const deactivationReasons = [
    { key: 1, value: 'Solicitação do vedendor', label: 'Solicitação do vedendor' },
    { key: 2, value: 'Vendedor não engajado', label: 'Vendedor não engajado' },
    { key: 3, value: 'Atrito com a Multimarca', label: 'Atrito com a Multimarca' },
    { key: 4, value: 'Funcionário do grupo', label: 'Funcionário do grupo' },
    !user?.realUser?.features.multimarca && { key: 5, value: 'Atrito com a marca', label: 'Atrito com a marca' },
    { key: 6, value: 'Outros', label: 'Outros' },
  ]

  const FilterOpts = {
    filterFields: [
      { propName: "affiliate_code", propText: "Codigo" },
      { propName: "affiliate_name", propText: "Nome" },
      { propName: "CPF", propText: "Cpf" }
    ],
    updateFilter: (e) => setFilter(e)
  }

  const data = useMemo(() => {
    return props.data?.children
      .filter((x) => props.statusAff === "1" ? x.deactivated_at === null : x.deactivated)
      .sort((x, y) => x.created_at < y.created_at ? 1 : -1);
  }, [props.data.children, props.statusAff]);

  const result = useMemo(() => filteredResults.length > 0 ? pageList(filteredResults, page, rowsPerPage) : []
    , [page, rowsPerPage, filteredResults]
  )

  const onHandlerFilter = useCallback(() => {
    setPage(0)
    setFilteredResults(
      Object.entries(filter).reduce((l, [k, p]) => {
        return l.filter((o) => {
          if (k === "CPF") {
            return o.info[k].toUpperCase().includes(p.toUpperCase())
          } else {
            return o[k].toUpperCase().includes(p.toUpperCase())
          }
        })
      }, data)
    )
    if (filteredResults.length > 0) {
      setStatus('result')
    } else {
      setStatus('empty')
    }
  }, [filter, data, filteredResults.length])

  useEffect(() => {
    onHandlerFilter()
  }, [onHandlerFilter])

  return (
    <>
      <Modal isUploading={!reasonRemoveVendor || loadingRemoveVendor} modalName="DESATIVAR VENDEDOR(A)" closeName="Cancelar" onClose={() => { setOpen(false); setCommentRemoveVendor(undefined); setReasonRemoveVendor(undefined) }} open={open} actionName="Desativar" action={(a) => { onConfirm(reasonRemoveVendor, commentRemoveVendor); setCommentRemoveVendor(undefined); setReasonRemoveVendor(undefined) }}>
        <div className='modal_affiliate_deactivation--div'>
          <p>Ao desativar {editInfo.full_name}, você bloqueia o código do mesmo para uso. Caso deseje prosseguir, insira o motivo do desligamento abaixo:</p>
          <SomaRadioButton name="deactivationReason" options={deactivationReasons} onChange={(e) => setReasonRemoveVendor(e.target.value)} />
          <p>Insira um comentário se necessário:</p>
          <SomaTextEditor setText={setCommentRemoveVendor} />
        </div>
      </Modal >

      <Modal open={openModal} modalName={edit ? "Editar" : "Cadastrar"} onClose={() => { setOpenModal(false); setEdit(undefined); }} hideButtons>
        <FormVendedor pai={props.data} reload={reload} />
      </Modal>
      <Modal open={openModalEdit} modalName={"Editar"} onClose={() => { setOpenModalEdit(false) }} hideButtons>
        <FormVendedorEdit data={editInfo} reload={reload} />
      </Modal>
      <TableSettings >
        <ToggleFilter {...toggleOpts} />
        <div className='tableSettings--div'>
          <PrimaryButton disabled={props.status.bloqueio} onClick={() => { setOpenModal(true); setEdit(undefined); }} >Cadastrar Vendedor</PrimaryButton>
          <SomaFilter returnOne {...FilterOpts} />
        </div>
      </TableSettings>
      <SomaStatus status={status}>
        <SomaTable size="small" results={result} columns={[
          {
            propName: "info", component: Tabelas, componentProps:
            {
              colunas: [
                { propName: "info", propText: "Nome vendedor(a)", component: (props) => props.line.info.full_name, highlighted: true },
                { propName: "info", propText: "CPF", component: (props) => parseCPF(props.line.info.CPF) },
                { propName: "info", propText: "Instagram", component: (props) => parseSocialMedia(props.line.info.instagram) },
                { propName: "info", propText: "Email", component: (props) => props.line.info.email },
                { propName: "affiliate_code", propText: "Código vendedor" },
                props.statusAff === "1" && { propName: "info", component: AffiliateButtonGroup, componentProps: { reload, setEdit, setOpen, onConfirm, setOnConfirm, setEditInfo, setOpenModalEdit, setLoadingRemoveVendor } },
                props.statusAff === "2" && { propName: "deactivated_at", propText: "DATA DESATIVAÇÃO", component: ConverteData },
                props.statusAff === "2" && { propName: "info", propText: "MOTIVO", component: (props) => props.line.deactivated?.reason },
              ]
            }
          }
        ]}
          {...{
            page, setPage, rowsPerPage, setRowsPerPage, hasButton,
            total: filteredResults.length > 0 ? filteredResults.length : 0,
          }} />
      </SomaStatus>
    </>
  );
};

export default ListaAfiliados;